import { useEffect, useState } from 'react';
import { getRouteNoticeMutedUntil, ROUTE_NOTICE_PREFERENCE_EVENT } from '../utils/routeNotice';

export default function useRouteNoticePreference() {
  const [mutedUntil, setMutedUntil] = useState(getRouteNoticeMutedUntil);

  useEffect(() => {
    const update = () => setMutedUntil(getRouteNoticeMutedUntil());
    window.addEventListener('storage', update);
    window.addEventListener(ROUTE_NOTICE_PREFERENCE_EVENT, update);
    update();
    return () => {
      window.removeEventListener('storage', update);
      window.removeEventListener(ROUTE_NOTICE_PREFERENCE_EVENT, update);
    };
  }, []);

  return mutedUntil;
}
